import {
    useWorkspaceTaskGroupCounts,
    useWorkspaceTaskGroups,
} from "@api/taskGroup.api";
import { TaskGroupsListBase } from "./TaskGroupsListBase";

interface Props {
    search: string;
    canManageTaskGroups: boolean;
}

export const WorkspaceTaskGroupsList = ({
    search,
    canManageTaskGroups,
}: Props) => {
    const workspaceTaskGroupsQuery = useWorkspaceTaskGroups();
    const workspaceTaskGroupCountsQuery = useWorkspaceTaskGroupCounts();

    return (
        <TaskGroupsListBase
            search={search}
            canManageTaskGroups={canManageTaskGroups}
            taskGroups={workspaceTaskGroupsQuery.data}
            isTaskGroupsFetched={workspaceTaskGroupsQuery.isFetched}
            counts={workspaceTaskGroupCountsQuery.data}
            isCountsFetched={workspaceTaskGroupCountsQuery.isFetched}
            scope="workspace"
        />
    );
};
